import { render, staticRenderFns } from "./Gvd.vue?vue&type=template&id=012be4da&scoped=true"
import script from "./Gvd.vue?vue&type=script&lang=ts"
export * from "./Gvd.vue?vue&type=script&lang=ts"
import style0 from "./Gvd.vue?vue&type=style&index=0&id=012be4da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012be4da",
  null
  
)

export default component.exports